// extracted by mini-css-extract-plugin
export default {"panel":"GradientCTA_panel__J-dMr","landing":"GradientCTA_landing__O9tpT"};